// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TO_action_YOU_HAVE_TO_BE_loggedIn = "Pro %(action)s mus\u00ed\u0161 %(loggedIn)s.";
export const TO_BE_LOGGED_IN = "b\u00fdt p\u0159ihl\u00e1\u0161en\u00e1";
